import { LocationAttendeeState } from './types';

export const state = (): LocationAttendeeState => initialState();

export const initialState = (): LocationAttendeeState => ({
  locationAttendees: {
    //TODO remove when was made backend
    items: [],
    isLoading: false,
    total: 0, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [],
    },
  },
});
